import { render } from "./IpRangesTabStorage.vue?vue&type=template&id=5799f02e&scoped=true"
import script from "./IpRangesTabStorage.vue?vue&type=script&lang=js"
export * from "./IpRangesTabStorage.vue?vue&type=script&lang=js"

import "./IpRangesTabStorage.vue?vue&type=style&index=0&id=5799f02e&lang=scss&scoped=true"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5799f02e"]])

export default __exports__